import * as glMatrix from '../../../../node_modules/gl-matrix';
import { Tool } from './tool.js';
import { BrushStroke } from '../../scene/stroke/brush.js';
export class BrushTool extends Tool {
    _size: number;
    _hardness: number;
    _color: glMatrix.vec4;
    edit: boolean;
    stroke: BrushStroke;

    constructor(gl: any, width: number, height: number) {
        super(gl, width, height, 'brush', 'Pinceau');
        var self = this;
        try {
            self._size = JSON.parse(window.localStorage.getItem('PSBrushTool_size') || '');
            if (isNaN(self._size) || self._size === null) {
                self._size = 200;
            }
        } catch (e) {
            self._size = 200;
        }
        try {
            self._hardness = JSON.parse(window.localStorage.getItem('PSBrushTool_hardness') || '');
            if (isNaN(self._hardness) || self._hardness === null) {
                self._hardness = 0.5;
            }
        } catch (e) {
            self._hardness = 0.5;
        }
        try {
            self._color = JSON.parse('[' + window.localStorage.getItem('PSColor') + ']');
            if (self.color.length < 2) {
                self._color = glMatrix.vec4.create();
                self._color[3] = 1;
            }
        } catch (e) {
            self._color = glMatrix.vec4.create();
            self._color[3] = 1;
        }
        self.edit = false;
        self.stroke = new BrushStroke(gl, width, height);
    }

    get size() {
        return this._size;
    }

    set size(value) {
        try {
            window.localStorage.setItem('PSBrushTool_size', value.toString());
        } catch (e) {
        }
        this._size = value;
    }

    get hardness() {
        return this._hardness;
    }

    set hardness(value) {
        try {
            window.localStorage.setItem('PSBrushTool_hardness', value.toString());
        } catch (e) {
        }
        this._hardness = value;
    }

    get color() {
        return this._color;
    }

    set color(value) {
        try {
            window.localStorage.setItem('PSColor', JSON.stringify(value));
        } catch (e) {
        }
        this._color = value;
    }

    destroy() {
        super.destroy();
        this.stroke.destroy();
    }

    static copy(value) {
        var result = new BrushTool(value._gl, value._width, value._height);
        result.size = value.size;
        result.hardness = value.hardness;
        result.color = value.color;
        result.edit = value.edit;
        return result;
    }

    addPoint(point) {
        var self = this;
        self.stroke.addPoint(point, self.size / self._width);
        self._touch = true;
    }
}
